export default __webpack_public_path__ + "static/media/doctor-consultation-main.0e926a5f.svg";